import session from './session'
import { rootAPI } from './settings'

const fetEventListWithRetention = (params = {}) => {
  return session.get(rootAPI + 'data-retention/all-events', params)
}

const updateEventRetention = (eventName, retentionDays) => {
  return session.post(rootAPI + 'data-retention/events/retention', {
    event: eventName,
    days: retentionDays
  })
}

export { fetEventListWithRetention, updateEventRetention }
